import _request from "./_request";
import {Message} from "element-ui";
import cache_car from "../cache/cache_car";
import _object from "../utils/_object";




let letters = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
];

let _car = {

    letters : letters,

    init: function (activity_id, callback = null) {
        let data = {};
        data.activity_id = activity_id
        let params = _request._params('Activity', 'brand_series', data);
        _request._post_base(params, function (response) {

            if (response.code !== _request.success) {
                Message.info(response.info);
                return;
            }

            cache_car.set(response.data)
            if (typeof callback === 'function')
                callback(response.data)

        }, 0)
    },

    get: function () {
        if (cache_car.empty())
            return [];

        return cache_car.get()
    },

    get_brands: function () {
        let list = this.get()
        let automaker_list = {};
        for (let letter in list)
        {
            for (let brand_id in list[letter])
            {
                for (let automaker_id in list[letter][brand_id].children)
                {
                    automaker_list[automaker_id] = list[letter][brand_id].children[automaker_id];
                }
            }
        }
        return automaker_list
    },

    get_brand_id: function (automaker_id) {
        let list = this.get()
        for (let letter in list)
        {
            for (let brand_id in list[letter])
            {
                for (let id in list[letter][brand_id].children)
                {
                    if (automaker_id == id)
                        return brand_id;
                }
            }
        }
        return 0;
    }

};

export default _car
